import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { GradientTextAction, Poppins, Spacer } from 'src/common';
import styled from 'styled-components';
import { ControlInput, useControlFrameworksListQuery } from 'src/graphql/_generated';
import { Row } from './comps';
import { isQueryLoading } from 'src/graphql';

const Container = styled.div`
  .frameworks-container {
    display: flex;
    flex-direction: column;
    gap: 21px;
  }
`;

export const FrameworkControlsManager: React.FC = () => {
  const { values, setFieldValue, setStatus, touched, setFieldTouched } = useFormikContext<ControlInput>();

  const controlIds = values.frameworkControlIds?.filter((el): el is string => !!el) || [];

  const { data, loading, networkStatus } = useControlFrameworksListQuery();
  const isLoading = isQueryLoading({ loading, data, networkStatus });

  useEffect(() => {
    const hasIncompleteRows = controlIds.some((el) => !el);
    setStatus({ frameworkControlsValid: controlIds.length === 0 || !hasIncompleteRows });
  }, [controlIds, setStatus]);

  const handleControlChange = (idx: number, controlId: string) => {
    const newControlIds = [...controlIds];
    newControlIds[idx] = controlId;
    setFieldValue('frameworkControlIds', newControlIds);
  };

  const handleAddRow = () => {
    const newControlIds = [...controlIds, ''];
    setFieldValue('frameworkControlIds', newControlIds);
  };

  return (
    <Container>
      <Poppins weight={600}>FRAMEWORK:</Poppins>
      <Spacer $px={20} />
      <div className="frameworks-container">
        {(isLoading && controlIds.length > 0 ? controlIds.slice(0, 1) : controlIds).map((controlId, idx) => (
          <Row
            key={controlId || `new-${idx}`}
            idx={idx}
            controlId={controlId}
            controlTouched={Array.isArray(touched.frameworkControlIds) ? touched.frameworkControlIds[idx] : false}
            onControlChange={handleControlChange}
            onControlBlur={(idx) => setFieldTouched(`frameworkControlIds.${idx}`, true)}
            onRemove={(idx) =>
              setFieldValue(
                'frameworkControlIds',
                controlIds.filter((_, i) => i !== idx),
              )
            }
            canRemove={!values.origin}
            isLoading={isLoading}
            data={data}
          />
        ))}

        {!controlIds.length && !values.origin && (
          <GradientTextAction
            style={{ display: 'inline-block', marginRight: 'auto', textTransform: 'none', cursor: 'pointer' }}
            weight={500}
            onClick={handleAddRow}
            data-cy="add-framework-control"
          >
            + <span className="underline">Add source framework</span>
          </GradientTextAction>
        )}
      </div>
    </Container>
  );
};
